interface Menu {
	default: MenuModes;
	desktop?: MenuModes;
	tablet?: MenuModes;
	mobile?: MenuModes;
}

interface MenuModes {
	burger: MenuItem[];
	left: MenuItem[];
	right: MenuItem[];
	center: MenuItem[];
}

enum MenuPosition {
	left = 'left',
	center = 'center',
	right = 'right',
	burger = 'burger',
}

enum CreateButtonOption {
	folder = 'create_folder',
	publicationFromTemplate = 'create_prop_tpl',
	proposalFromFile = 'create_prop_file',
	importFile = 'import_file',
	externalLink = 'create_ext_link',
}

interface MenuItem {
	type: MenuItemType;
	label: string;
	icon: string;
	target: string;
	badge?: number;
	options?: CreateButtonOption[];
}

enum MenuItemType {
	Home = 'goto_homepage',
	Gallery = 'goto_gallery',
	Selection = 'goto_favorites',
	New = 'goto_new',
	Downloads = 'goto_downloads',
	Parameters = 'goto_parameters',
	Documents = 'goto_documents',
	SharedWithMe = 'goto_sharedWithMe',
	Link = 'link',
	Asset = 'asset',
	Folder = 'folder',
	Page = 'page',
	Logo = 'logo',
	BurgerButton = 'burger_btn',
	SelectionButton = 'favorites_btn',
	DownloadButton = 'download_btn',
	SearchButton = 'search_btn',
	ShareButton = 'share_btn',
	LogOut = 'logout_btn',
	Title = 'title',
	CancelButton = 'cancel',
	Profile = 'profile',
	ProposalStats = 'proposal_stats',
	ProposalArchive = 'proposal_archive',
	CreateButton = 'create_btn',
	CookieSettings = 'cookie_settings',
	CreateNote = 'notes',
	Notes = 'notes_list',
	BackToPublication = 'back_btn',
}

export {
	Menu,
	MenuModes,
	MenuItem,
	MenuItemType,
	MenuPosition,
	CreateButtonOption,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/typings/menu.ts